




































interface quaterList {
    text: string;
    min: string;
    max: string;
}
let bindClickBlank = (e: any, vue: any) => {
    if (vue.showPanel && !e.target.classList.contains("quater-dom")) {
        vue.showPanel = false;
    }
};
import { Component, Prop, Vue, Watch, Model } from "vue-property-decorator";
 
@Component({})
export default class QuaterSelector extends Vue {
    @Prop({ type: [String, Date], default: new Date() })
    date?: Date;

    @Prop({ type: [String, Number] })
    endDate?: number;

    @Prop({ type: [String, Number] })
    startDate?: number;

    year: number = Number(new Date().getFullYear());
    showPanel: boolean = false;

    quaters: quaterList[] = [
        {
            text: "第一季度",
            min: "01",
            max: "03"
        },
        {
            text: "第二季度",
            min: "04",
            max: "06"
        },
        {
            text: "第三季度",
            min: "07",
            max: "09"
        },
        {
            text: "第四季度",
            min: "10",
            max: "12"
        }
    ];

    bodyClick(e: any) {
        bindClickBlank(e, this);
    }

    // 监听date值
    @Watch("date")
    dateChange(val: any) {
        this.year = +val.getFullYear();
    }

    mounted() {
        document.body.addEventListener("click", this.bodyClick);
    }

    beforeDestroy() {
        document.body.removeEventListener("click", this.bodyClick);
    }

    // 获取当前选中状态的季度
    getActiveQuater(min: string, max: string) {
        if (this.date) {
            let now = this.$utils.simpleDateFormat(this.date, "m");
            if (
                +now >= +(String(this.year) + min) &&
                +now <= +(String(this.year) + max)
            ) {
                return true;
            } else {
                return false;
            }
        }
    }
    
    // 季度选择框中的内容
    get visDate() {
        if (this.date) {
            let month = this.date.getMonth() + 1;
            let quater = Math.ceil(month / 3);
            return this.date.getFullYear() + ".Q" + quater;
        } else return "";
    }

    // 最小的时间
    get min() {
        if (this.startDate) {
            return this.$utils.simpleDateFormat(new Date(this.startDate), "m");
        }
    }
    // 最大的时间
    get max() {
        if (this.endDate) {
            return this.$utils.simpleDateFormat(new Date(this.endDate), "m");
        }
    }

    // 是否展开季度选择
    showQuaterPanel(e: any) {
        this.showPanel = !this.showPanel;
    }

    // 改变年分
    changeYear(type: number) {
        if (type === 0) {
            if (this.startDate) {
                if (this.year > new Date(this.startDate).getFullYear())
                    this.year--;
            }
        } else {
            if (this.endDate) {
                if (this.year < new Date(this.endDate).getFullYear())
                    this.year++;
            }
        }
    }

    // 监听季度选中
    @Watch("showPanel")
    showPanelChange(val: boolean) {
        if (this.date) {
            if (!val) this.year = this.date.getFullYear();
        }
    }

    @Watch("date")
    dateChanged(val: Date) {
        
    }

    // 改变季度
    changeQuater(quater: any, disabled: boolean) {
        if (!disabled) {
            this.showPanel = false;
            this.$emit(
                "quaterChange",
                String(this.year) + String(quater.min),
                String(this.year) + String(quater.max)
            );
        }
    }
}
